module.exports = __webpack_public_path__ + "static/media/Download.7ab47d2b.svg";